import { takeLatest, select, put, all, call } from "redux-saga/effects";
import { PROGRAM_SELECTIONS_ITEMS, PROGRAM_COLLECTIONS_ITEMS } from "../../constants/state";
import getData from "../../functions/getData";
import { PERIOD } from "../../constants/programSectionTypes";
import { MOVIE } from "../../constants/itemTypes";
import actionTypes from "../../actions/actionTypes";
import { movieOrderSelector } from "./helpers";


const selectionsSelector = state => getData(state, PROGRAM_SELECTIONS_ITEMS).toJS()
const collectionsSelector = state => getData(state, PROGRAM_COLLECTIONS_ITEMS).toJS()



function* updateCollectionItems(pk, collectionItems) {
    yield put({
        type: actionTypes.ITEMCOLLECTIONS_UPDATE_ITEM_ITEMS,
        meta: {},
        payload: {
            pk: pk,
            items: collectionItems
        }
    })
}


function* reorderItems() {
    const orderIm = yield select(movieOrderSelector)
    const order = yield all(orderIm.toJS())
    const selections = yield select(selectionsSelector)
    const collections = yield select(collectionsSelector)
    const selectionKeys = yield all(Object.keys(selections))

    const selectionKeysLength = yield selectionKeys.length
    let s =  yield 0

    for(s; yield s < selectionKeysLength; yield s++) {
        const sKey = yield selectionKeys[s]
        const selection = yield selections[sKey]

        if(PERIOD === selection.filterType) {
            const collectionIds = yield all(selection.collections)
            const collectionIdsLength = yield collectionIds.length
            let c = yield 0

            for (c; yield c < collectionIdsLength; yield c++) {
                const collectionId = yield collectionIds[c]
                const collection = yield collections[collectionId]

                if(!collection.edited) {
                    const newCollectionItems = yield all([])
                    const collectionItems = yield all(collection.items)
                    const orderLength = yield order.length
                    let o = yield 0
                    
                    for (o; yield o < orderLength; yield o++) {
                        const id = yield order[o]
                        
                        const collectionItem = collectionItems.find(function (item) {
                            return MOVIE === item.type && id === item.id
                        })
                        
                        if(collectionItem) {
                            yield newCollectionItems.push(collectionItem)
                        }
                    }
                    yield call(updateCollectionItems, collectionId, newCollectionItems)
                }
            }
        }
    }
}

function* watchReorderProgramItem() {
    try {
        yield takeLatest(actionTypes.PROGRAM_ITEM_REORDER_REQUEST, reorderItems)
    } catch(e) {
        // ToDo: general error
        console.log('error!!!!!', e.message)
    }
}


export default watchReorderProgramItem;